import { render, staticRenderFns } from "./ladda-button.vue?vue&type=template&id=deb0fdbe&"
import script from "./ladda-button.vue?vue&type=script&lang=js&"
export * from "./ladda-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports